import App from "./App";

export default function AdminRoute() {
  return (
    
        <App />
    
  );
}
